exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".change-projects-block {\n  position: relative;\n}\n.change-projects-block > .operations {\n  position: absolute;\n  top: -38px;\n  right: 8px;\n}\n#batchUpload {\n  display: inline-block;\n  width: 0px;\n  height: 0px;\n  overflow: hidden;\n}\n", ""]);

